export const STARTUP_STAGES = [
  "Ideation",
  "Traction",
  "Break-Even",
  "Profit",
  "Scaling",
  "Stable",
];
